'use client';

import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Hide } from '../ui/Icons';
import { cn } from '@/lib/utils';

export interface HeadlessModalProps {
  isOpen: boolean;
  closeModal: () => void;
  children?: React.ReactNode;
}

export default function ShowAllReviewsModal({
  isOpen,
  closeModal,
  children,
}: HeadlessModalProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className={cn('relative z-50 overflow-y-auto')}
        onClose={closeModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 w-screen overflow-hidden">
          <div
            className={cn(
              'flex min-h-full items-center justify-center text-center'
            )}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={cn(
                  'relative max-h-screen w-full transform overflow-y-auto bg-white text-left shadow-xl transition-all md:max-h-[90vh] md:w-[725px] md:rounded-2xl'
                )}
              >
                <Hide
                  className={cn(
                    'absolute right-5 top-5 cursor-pointer text-neutral-400 transition-colors hover:text-primary-700'
                  )}
                  onClick={() => closeModal()}
                />
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
